import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import apiCalls from "../utils/apiCalls";
import utils from "../utils/utils";
import Loader from "../components/loader";
import ErrorMessage from "../components/errorMessage";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {Route} from "react-router";
import MarketplaceAdminPayoutReportsIndex from "./marketplaceAdminPayoutReportsIndex";
import MarketplaceAdminPayoutReportView from "./marketplaceAdminPayoutReportView";

const MarketplaceAdminPayoutReports = ({marketplace, match}) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [payoutReports, setPayoutReports] = useState([]);

  useEffect(() => {
    setLoading(true);
    setError(null);
    if (!marketplace) {
      return
    }
    apiCalls.getPayoutReports({
      marketplaceId: marketplace.id,
    })
      .then((result) => {
        if (result.data && result.data.payoutReports) {
          setPayoutReports(result.data.payoutReports);
          setLoading(false);
        }
      })
      .catch((errors) => {
        setError(utils.getErrorMessageFromResponse(errors));
        setLoading(false);
      });
  }, [marketplace]);

  return (
    <>
      <Loader show={loading}/>
      <ErrorMessage error={error}/>

      <Route exact path={`${match.path}`}
             render={props => <MarketplaceAdminPayoutReportsIndex payoutReports={payoutReports} {...props}/> }/>
      <Route path={`${match.path}/view/:payoutReportId`}
             render={props => <MarketplaceAdminPayoutReportView payoutReports={payoutReports} {...props}/> }/>
    </>
  );
}

MarketplaceAdminPayoutReports.propTypes = {
  marketplace: PropTypes.object.isRequired,
};

MarketplaceAdminPayoutReports.defaultProps = {};

function mapStateToProps(state) {
  return {
    marketplace: state.marketplace.marketplace,
  };
}

export default withRouter(connect(mapStateToProps)(MarketplaceAdminPayoutReports));